export interface News {
    id: string,
    name: string,
    type: string,
    content: NewsContent[],
    fromDate: string,
    toDate: string,
    status: StatusEnum,
    restricted: boolean,
}

export interface NewsDto {
    id: string,
    name: string,
    type: string,
    content: NewsContent[],
    fromDate: string,
    toDate: string,
    instanceGroupIds: string[]
}

export interface NewsInstanceGroup {
    instanceGroupId: string,
    name: string
}

export interface TextImageNews {
    language: string,
    title: string,
    text: string,
    file: string,
    duration: string,
    buttonText: string
}

export interface ImageNews {
    language: string,
    url: string,
    file: string,
    duration: string
}

export interface VideoNews {
    language: string,
    url: string,
    file: string
}

export interface NewsContent {}

export interface TextContent {
    newsTitle: string,
    text: string,
    duration: number,
    language: string
}

export interface ImageContent {
    url: string,
    duration: number
}

export interface NewsRenderModel {
    id: string,
    type: string,
    blobUrl: string,
    content: NewsContent,
    duration: number,
    publishDate: string
}

export enum StatusEnum {
    Disabled,
    Active
}

export enum LanguageEnum {
    English,
    Danish,
    Swedish
}

// languages
export const Languages = [
    {
        text: "english",
        code: "en"
    },
    {
        text: "danish",
        code: "da"
    },
    {
        text: "german",
        code: "de"
    },
    {
        text: "swedish",
        code: "sv"
    },
    {
        text: "norwegian",
        code: "nn"
    },
    {
        text: "finnish",
        code: "fn"
    },
    {
        text: "french",
        code: "fr"
    },
    {
        text: "greenland",
        code: "kl"
    },
    {
        text: "welsh",
        code: "cy"
    },
    {
        text: "dutch",
        code: "nl"
    },
    {
        text: "mexican",
        code: "es"
    }
];
